module.exports = __webpack_public_path__ + "static/img/qq.565c5b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/qq.png
// module id = sDBu
// module chunks = 1